import { render, staticRenderFns } from "./WeekSkeletonLoader.vue?vue&type=template&id=0ee1ccc2"
import script from "./WeekSkeletonLoader.vue?vue&type=script&lang=js"
export * from "./WeekSkeletonLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports